module.exports = __webpack_public_path__ + "img/banner.697d0e6d.jpg";